{
  "dismiss": "Zignoruj"
}
